module.exports = __webpack_public_path__ + "static/img/anxun22.8fe3b671.png";